import { render, staticRenderFns } from "./CostPivotBQ.vue?vue&type=template&id=23a7ccfe&scoped=true"
import script from "./CostPivotBQ.vue?vue&type=script&lang=js"
export * from "./CostPivotBQ.vue?vue&type=script&lang=js"
import style0 from "./CostPivotBQ.vue?vue&type=style&index=0&id=23a7ccfe&prod&lang=scss&scoped=true"
import style1 from "./CostPivotBQ.vue?vue&type=style&index=1&id=23a7ccfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7ccfe",
  null
  
)

export default component.exports